import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post } from '../api/client.js';

const KEY = ['jha', 'today'];

export function useJhaToday() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => get('/api/jha/today'),
    staleTime: 60_000,
  });
}

export function useSubmitJha() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (answers) => post('/api/jha/submit', { answers, source: 'ui' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
      // CrewRosterPanel + admin dashboard both surface today's JHA status —
      // refetch so the foreman/admin sees the green check immediately.
      qc.invalidateQueries({ queryKey: ['foreman', 'crew-status'] });
      qc.invalidateQueries({ queryKey: ['admin', 'dashboard'] });
    },
  });
}
